// SEO utility functions for dynamic Schema.org JSON-LD insertion

export const insertSchemaOrg = (schema: object) => {
  const scriptId = 'schema-org-jsonld';
  let script = document.getElementById(scriptId);
  
  if (!script) {
    script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  
  script.textContent = JSON.stringify(schema);
};

export const getLocalBusinessSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${siteUrl}/#business`,
    "name": "Satori Energia",
    "image": "https://static.readdy.ai/image/402fb013a15abdbe1b740b2d8ca8aa4c/107bdeca5d3137440a917d6bc5b4d98f.png",
    "description": "Aluguel de Caminhão Munck em Picos-PI e região até 500 km. Satori Energia oferece içamento, transporte e instalação de cargas pesadas com segurança. Capacidade 20 toneladas, alcance 11,28m. Operador incluso.",
    "url": siteUrl,
    "telephone": "+5589933009903",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Picos",
      "addressRegion": "PI",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-7.0776",
      "longitude": "-41.4669"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "-7.0776",
        "longitude": "-41.4669"
      },
      "geoRadius": "500000"
    },
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday"],
        "opens": "08:00",
        "closes": "12:00"
      }
    ],
    "sameAs": [
      "https://instagram.com/satorienergia"
    ]
  };
};

export const getServiceSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${siteUrl}/#service`,
    "serviceType": "Aluguel de Caminhão Munck",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Satori Energia",
      "url": siteUrl
    },
    "areaServed": {
      "@type": "Place",
      "name": "Picos-PI e região até 500km"
    },
    "description": "Aluguel de caminhão Munck com operador certificado para içamento, transporte e instalação de cargas pesadas. Capacidade de 20 toneladas, alcance vertical de 11,28m e horizontal de 9,52m.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "Sob consulta",
      "priceCurrency": "BRL"
    }
  };
};

export const getFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "O aluguel do Munck inclui operador?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim! Todos os nossos serviços incluem operador certificado NR-11, NR-12 e NR-35, com vasta experiência em operações de içamento. A segurança e qualidade do serviço começam com profissionais capacitados."
        }
      },
      {
        "@type": "Question",
        "name": "Como é calculado o valor do orçamento?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O orçamento considera: tipo de operação, peso e dimensões da carga, distância de deslocamento, tempo estimado de operação, complexidade do acesso ao local. Por isso pedimos essas informações no primeiro contato - para oferecer um preço justo e preciso."
        }
      },
      {
        "@type": "Question",
        "name": "Vocês atendem em finais de semana ou feriados?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim, atendemos conforme disponibilidade de agenda. Para serviços urgentes em finais de semana ou feriados, entre em contato o quanto antes para verificarmos a possibilidade de mobilização."
        }
      },
      {
        "@type": "Question",
        "name": "É necessária uma visita técnica antes do serviço?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Na maioria dos casos, não. Com as informações corretas (tipo de carga, peso, altura necessária, fotos do local), conseguimos planejar e executar com segurança. Em casos específicos ou operações complexas, podemos recomendar uma visita prévia."
        }
      },
      {
        "@type": "Question",
        "name": "Quais informações devo enviar no WhatsApp para pedir um orçamento?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Para agilizar, envie: 1) Tipo de carga/serviço (ex: transformador 15 ton, poste 12m) 2) Local da operação (cidade/região) 3) Peso estimado 4) Altura/alcance necessário 5) Data desejada 6) Duração estimada. Se possível, envie fotos do local e da carga."
        }
      },
      {
        "@type": "Question",
        "name": "Quais são as limitações de capacidade e alcance do Munck?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Nosso Munck IMAP IM 20-9,5/22 possui capacidade máxima de 20 toneladas, alcance vertical de até 11,28 metros e alcance horizontal de até 9,52 metros. A capacidade real varia conforme a distância - quanto mais distante, menor a capacidade de carga (seguindo a tabela do fabricante)."
        }
      }
    ]
  };
};

export const getWebsiteSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${siteUrl}/#website`,
    "url": siteUrl,
    "name": "Satori Energia",
    "description": "Aluguel de Caminhão Munck em Picos-PI com operador certificado",
    "publisher": {
      "@type": "Organization",
      "name": "Satori Energia",
      "@id": `${siteUrl}/#business`
    },
    "inLanguage": "pt-BR"
  };
};

export const getProductSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Aluguel de Caminhão Munck IMAP IM 20-9,5/22",
    "description": "Caminhão Munck com capacidade de 20 toneladas, alcance vertical de 11,28m e horizontal de 9,52m. Inclui operador certificado NR-11, NR-12 e NR-35.",
    "brand": {
      "@type": "Brand",
      "name": "IMAP"
    },
    "model": "IM 20-9,5/22",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "Sob consulta",
      "priceCurrency": "BRL",
      "url": siteUrl,
      "seller": {
        "@type": "Organization",
        "name": "Satori Energia"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "1"
    }
  };
};

export const getBreadcrumbSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": siteUrl
      }
    ]
  };
};

// Combined schema for homepage
export const getHomePageSchema = () => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      getWebsiteSchema(),
      getLocalBusinessSchema(),
      getServiceSchema(),
      getProductSchema(),
      getFAQSchema(),
      getBreadcrumbSchema()
    ]
  };
};
